import { Component, inject, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../../button/button.component';
import { ModalComponent } from '../modal.component';
import { ClIcon } from '@corelabs/angular/ui';
import { Maximize, Minimize, X } from 'lucide';

/** The modal header's icon buttons — maximize/restore toggle plus close. */
@Component({
    selector: 'app-modal-actions',
    templateUrl: './modal-actions.component.html',
    styleUrls: ['./modal-actions.component.css'],
    imports: [TranslatePipe, ButtonComponent, ClIcon],
})
export class ModalActionsComponent {
    protected readonly icons = { Maximize, Minimize, X };

    // The host modal, resolved through the element injector (these buttons only render inside one).
    protected readonly modal = inject(ModalComponent);

    readonly closed = output<void>();
}
